export function ModalContent({ children, align }) {
  const textAlign = () => {
    if (align === "center") {
      return "text-center";
    } else if (align === "end") {
      return "text-end";
    } else {
      return "text-start";
    }
  };
  return <div className={`my-5 ${textAlign()} mx-7`}>{children}</div>;
}
